// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicyContent":"PrivacyPolicy_privacyPolicyContent__1vwuo","textJustify":"PrivacyPolicy_textJustify__Q6heP"};